import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
interface ClaimPrizeProps {
  width?: number | string;
  height?: number | string;
}

const ClaimPrize: React.FC<ClaimPrizeProps> = ({
  width = 244,
  height = 78,
}) => {
  const [clicked] = useState(false);
  const whaleText = "WHALE.IO";

  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(whaleText);
      toast.success("✅ FREE SPIN CODE IS COPIED!", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        theme: "dark",
      });

      // 📱 iOS friendly — otvori odmah, dok je klik aktivan
      window.open("https://whale.io/", "_blank");
    } catch {
      toast.error("❌ Copy failed");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "12px",
      }}
    >
      {/* Tekst koji se pojavi iznad dugmeta nakon klika */}
      {clicked && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px 59px",
            borderRadius: "232px",
            border: "2px dashed #41D9D7",
            background: "rgba(65, 217, 215, 0.20)",
            fontFamily: "Jost, sans-serif",
            fontWeight: 700,
            color: "#41D9D7",
            fontSize: "clamp(1rem, 2vw, 1.3rem)",
            userSelect: "text", // omogućava ručno selektovanje i kopiranje
          }}
        >
          {whaleText}
        </div>
      )}

      {/* SVG dugme */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 244 78"
        fill="none"
        style={{
          cursor: "pointer",
          transition: "transform 0.2s ease",
        }}
        onClick={handleClick}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.05)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
        }}
      >
        <path
          d="M230.059 13.3032C229.252 12.6773 228.412 12.0811 227.559 11.528C214.853 3.27812 197.13 2.32763 184.909 2.32763C180.927 2.32763 176.574 2.4402 171.208 2.67868C166.471 2.89066 161.654 3.17545 156.992 3.45364C147.58 4.01004 137.843 4.58961 128.301 4.58961C124.64 4.58961 121.259 4.50685 117.964 4.34123C111.27 4.00013 104.244 3.32779 96.8016 2.61573C85.4969 1.53276 73.8036 0.41333 62.459 0.41333C55.674 0.41333 49.7128 0.81079 44.2264 1.62552C40.9369 2.11565 37.756 2.77803 34.7697 3.5994C17.218 7.28219 6.70296 19.2977 3.02441 28.4783C-0.780008 37.9734 -0.333778 47.6145 4.27727 55.6227C8.81968 63.5114 24.1803 71.8603 39.2435 74.6294C46.9324 76.0435 55.3593 76.6992 65.7657 76.6992C71.9843 76.6992 78.2887 76.4674 84.3928 76.2455C86.3554 76.1727 88.3179 76.1029 90.2796 76.037C104.376 75.573 112.826 75.4011 121.442 75.4011C128.37 75.4011 135.332 75.52 143.656 75.6992C148.937 75.8117 154.377 76.1029 160.138 76.411C167.736 76.8151 175.596 77.2356 183.308 77.2356C194.647 77.2356 203.531 76.3317 211.272 74.3877C227.862 70.221 239.058 61.1465 241.987 49.4921C246.049 33.3368 242.147 21.4968 230.053 13.2999L230.059 13.3032Z"
          fill="#41D9D7"
        />
        <text
          x="50%"
          y="55%"
          textAnchor="middle"
          fill="white"
          fontSize="22"
          fontWeight="bold"
          fontFamily="Jost, sans-serif"
        >
          {clicked ? "COPY & CLAIM" : "CLAIM PRIZE"}
        </text>
      </svg>
      <ToastContainer />
    </div>
  );
};

export default ClaimPrize;
